import script from "./editStore.vue?vue&type=script&setup=true&lang=js"
export * from "./editStore.vue?vue&type=script&setup=true&lang=js"

import "./editStore.vue?vue&type=style&index=0&id=24eab60f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24eab60f"]])

export default __exports__